import React, { useRef } from 'react'
import { Text } from 'react-native'

export const HiddenText = ({
  text,
  setHeight,
}: {
  text?: string
  setHeight: (h: number) => void
}) => {
  const ref = useRef<Text>(null)
  return (
    <Text
      ref={ref}
      onLayout={() => {
        ref.current?.measure((fx, fy, width, height) => {
          setHeight(height)
        })
      }}
      // Measurement-only overlay: absolutely positioned over the real
      // TextInput to compute its auto-grow height. On react-native-web an
      // opacity:0 absolute element still paints above the in-flow
      // <textarea> and would swallow taps, leaving the field unfocusable
      // ("can't type"). pointerEvents none keeps it non-interactive.
      style={{
        fontSize: 16,
        padding: 10,
        width: '100%',
        position: 'absolute',
        opacity: 0,
        pointerEvents: 'none',
      }}
    >
      {text || ' '}
    </Text>
  )
}
